import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import {
  PresidioPasswordRequirement,
  evaluatePresidioPasswordRequirements,
} from '../../validators/presidio-password-requirements';

/**
 * CUSTOMIZATION: live password requirements checklist (Presidio policy).
 */
@Component({
  selector: 'prs-password-requirements',
  templateUrl: './presidio-password-requirements.component.html',
  styleUrls: ['./presidio-password-requirements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslatePipe],
})
export class PresidioPasswordRequirementsComponent {
  /** Current password field value. */
  readonly value = input<string | null | undefined>('');

  requirements(): PresidioPasswordRequirement[] {
    return evaluatePresidioPasswordRequirements(this.value());
  }
}
